import { defineMessages } from 'react-intl';

export const reviewPhotoModalMessages = defineMessages({
  drawerTitle: {
    id: 'reviews.detailDrawer.title',
    defaultMessage: 'Detail recenze',
  },
});
